// extracted by mini-css-extract-plugin
export default {"border":"style_border__c+04U","bg":"style_bg__tmnbb","txt1":"style_txt1__YoYhr","txt2":"style_txt2__4FKEz","enableIcon":"style_enableIcon__hDAnL"};